import { render, staticRenderFns } from "./ManageStorageTypesModal.vue?vue&type=template&id=0412634f&scoped=true"
import script from "./ManageStorageTypesModal.vue?vue&type=script&lang=js"
export * from "./ManageStorageTypesModal.vue?vue&type=script&lang=js"
import style0 from "./ManageStorageTypesModal.vue?vue&type=style&index=0&id=0412634f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0412634f",
  null
  
)

export default component.exports